<template>
  <div>
    <div class="border-bottom-gray grid-12 grid-column-gap-0 align-center width-100">
      <div class="span-1 p-10">
        <img v-if="post.node.media.croppedUrl" :src="post.node.media.croppedUrl" width="52" height="64" />
        <img v-else class="width-100" src="@/assets/img/icons/icon-upload-image.svg" />
      </div>
      <div class="span-1 width-100 center-cell" />
      <div class="span-2 pl-20 center-cell">
        <p class="subheading-1">
          {{ post.node.createdAt | moment("MM/DD/YY") }}
        </p>
      </div>

      <div class="span-2 pl-20 center-cell">
        <p class="truncate subheading-1">
          {{ post.node.actionCounts.views }}
        </p>
      </div>
      <div class="span-2 pl-20 center-cell">
        <p class="truncate subheading-1">
          {{ post.node.likeCounts }}
        </p>
      </div>
      <div class="span-2 pl-20 center-cell">
        <p class="truncate subheading-1">
          {{ post.node.actionCounts.follows }}
        </p>
      </div>
      <div class="span-2 flex align-center justify-center center-cell relative">
        <div class="underline" @click="$parent.$emit('delete-post', post.node.id)">Delete</div>
        <span
          class="pointer position-right bold order-accordion-icon hover-bg-black hover-color-green"
          @click="handleClick"
        >
          <span class="accordion--icon">{{ show ? "-" : "+" }}</span>
        </span>
      </div>
    </div>
    <transition name="fade" mode="in-out">
      <div v-if="show" class="pt-20 bg-light-green cursor-default p-20 border-bottom-gray">
        <h4 class="mb-10">Engaged Retailers:</h4>
        <span
          v-for="{ name, id } in post.node.engagedUsers"
          class="mr-15 underline"
          @click="navigateToRetailersProfile(id)"
        >
          {{ name }}
        </span>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "TableRow",
  props: {
    post: {},
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    handleClick() {
      this.show = !this.show;
    },
    navigateToRetailersProfile(retailerId) {
      window.open(`${location.origin}/retailer/${retailerId}`, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar-wrapper #sidebar ul {
  border-right: 1px solid black;
}

.center-cell {
  height: 100%;
  display: flex;
  align-items: center;
  border-right: 1px solid #d8d8d8;
}
</style>
